/* Aurelight PDP — fit option selector + image swap + qty stepper */
(function () {
  'use strict';

  function findVariants(sectionEl) {
    const id = sectionEl?.dataset.productSection;
    if (!id) return null;
    const node = document.querySelector('[data-variants-for="' + id + '"]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (_) {
      return null;
    }
  }

  function formatPrice(cents) {
    return '$ ' + Math.floor(cents / 100);
  }

  document.addEventListener('click', function (e) {
    // Quantity stepper
    const qtyBtn = e.target.closest('[data-qty-delta]');
    if (qtyBtn) {
      const delta = parseInt(qtyBtn.dataset.qtyDelta, 10);
      const input = qtyBtn.parentElement.querySelector('[data-qty-input]');
      if (input) {
        const next = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        input.value = next;
      }
      return;
    }

    // Fit option toggle
    const fitBtn = e.target.closest('.pdp-fit-option');
    if (fitBtn) {
      const row = fitBtn.closest('[data-fit-row]');
      if (!row) return;
      row.querySelectorAll('.pdp-fit-option').forEach((b) => b.classList.remove('selected'));
      fitBtn.classList.add('selected');
      const sectionEl = fitBtn.closest('[data-product-section]');
      const variants = findVariants(sectionEl);
      const opt1 = fitBtn.dataset.option1;
      if (variants && opt1) {
        const v = variants.find((vv) => vv.option1 === opt1);
        const form = sectionEl.querySelector('[data-pdp-form]');
        const idInput = form?.querySelector('[data-variant-id-input]');
        const atc = form?.querySelector('[data-atc-button]');
        if (v && idInput) idInput.value = v.id;
        if (v && atc) {
          if (v.available) {
            atc.disabled = false;
            atc.textContent = 'Add to Bag — ' + formatPrice(v.price);
          } else {
            atc.disabled = true;
            atc.textContent = 'Sold out';
          }
        }
      }
      return;
    }

    // Thumbnail image swap
    const thumb = e.target.closest('.pdp-thumb');
    if (thumb) {
      const gallery = thumb.closest('.pdp-gallery');
      const main = gallery?.querySelector('.pdp-main-image img');
      gallery
        ?.querySelectorAll('.pdp-thumb')
        .forEach((b) => b.classList.remove('active'));
      thumb.classList.add('active');
      if (main && thumb.dataset.image) main.src = thumb.dataset.image;
      return;
    }
  });
})();
